/** Storage path for the student's uploaded EHCP PDF (supports legacy and nested fields). */
export function getStudentEhcpStoragePath(student) {
  return student?.ehcp?.docPath || student?.ehcpFilePath || null;
}

/** Firestore ehcp_summaries document id for this student's latest upload. */
export function getStudentEhcpSummaryDocId(student) {
  return student?.ehcp?.summaryDocId || null;
}
